export default __webpack_public_path__ + "static/media/noStream.7f9d36fb.png";